/* eslint-disable class-methods-use-this */
export default class SidebarPesquisarView {
  static toggle() {
    document.querySelector('.sidebar-pesquisar').classList.toggle('sidebar-pesquisar--opened');
  }
}
